import { Resolver } from '@wellyes/react-router-extended';
import { HttpService } from '@core/services';
import {
  AccountingHttpService,
  DriverManagementHttpService,
  SiteHttpService,
} from '@core/services/http';
import { getProjectBundleIDParamFromUrl } from '@core/utils/methods';

export class AccountingDetailsResolver implements Resolver {
  async resolve(): Promise<void> {
    const [projectBundleID] = getProjectBundleIDParamFromUrl();

    await Promise.all([
      HttpService.getHttpRequests(AccountingHttpService).getAccountingSummary(
        projectBundleID,
      ),
      HttpService.getHttpRequests(SiteHttpService).getPSLocationCodeOptions(),
      HttpService.getHttpRequests(
        DriverManagementHttpService,
      ).getDriversListByWorkflow(),
    ]);
  }
}
